module.exports = __webpack_public_path__ + "media/index4.085f9896.webm";